import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import './ImageUpload.css';

interface ImageUploadProps {
  onUploadSuccess?: (imageUrl: string) => void;
}

const ImageUpload: React.FC<ImageUploadProps> = ({ onUploadSuccess }) => {
  const [file, setFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = event.target.files[0];
      setFile(selectedFile);
      setPreviewUrl(URL.createObjectURL(selectedFile));
      setError(null);
      setSuccess(null);
    } else {
      setFile(null);
      setPreviewUrl(null);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setError('이미지를 선택해주세요.');
      return;
    }

    try {
      setUploading(true);
      setError(null);
      setSuccess(null);

      const fileExt = file.name.split('.').pop();
      const fileName = `${Date.now()}.${fileExt}`;
      const filePath = `public/${fileName}`;

      const { error: uploadError } = await supabase.storage
        .from('images')
        .upload(filePath, file, { cacheControl: '3600', upsert: false });

      if (uploadError) {
        throw uploadError;
      }

      // 이미지 URL 가져오기
      const { data: publicUrlData } = supabase.storage
        .from('images')
        .getPublicUrl(filePath);

      if (!publicUrlData) {
        throw new Error('Public URL could not be retrieved.');
      }

      const publicImageUrl = publicUrlData.publicUrl;
      setSuccess('이미지 업로드 성공!\nURL: ' + publicImageUrl);
      if (onUploadSuccess) {
        onUploadSuccess(publicImageUrl);
      }

    } catch (e: any) {
      console.error('Error uploading image:', e);
      setError('이미지 업로드 실패: ' + e.message);
    } finally {
      setUploading(false);
      setFile(null);
      setPreviewUrl(null);
    }
  };

  return (
    <div className="image-upload-container">
      <h3>옷 이미지 업로드</h3>
      <input type="file" accept="image/*" onChange={handleFileChange} />
      {previewUrl && (
        <div className="image-preview">
          <img src={previewUrl} alt="Preview" />
        </div>
      )}
      <button onClick={handleUpload} disabled={!file || uploading}>
        {uploading ? '업로드 중...' : '업로드'}
      </button>
      {error && <p className="error-message">{error}</p>}
      {success && <p className="success-message">{success}</p>}
    </div>
  );
};

export default ImageUpload;
